/**
ff-who
0 high-school
1 transfer
2 adult
3 graduate
4 military-veteran
5 international

ff-d
0 associate
1 bachelors
2 masters
3 doctorate
4 certificate
5 none (unsure)

ff-loc
0 main-campus
1 boston
2 gloucester
3 online
4 none (unsure)

ff-lci
0 united-states
1 bangkok
2 czech-republic
3 spain
4 switzerland
5 thailand
6 online

ff-ac
0 business
1 communication-advertising
2 education
3 hospitality-management
4 liberal-studies
5 nursing
6 science-tech-math
7 social-sciences
8 sport-science-fitness-studies
9 visual-performing-arts

ff-acg
0 applied-behavior-analysis
1 athletics
2 business
3 computer-science
3 criminal-justice
4 education
5 homeland-security
6 hospitality
7 information-technology
8 interior-architecture
9 international-programs
10 liberal-studies
11 nursing
12 organizational-management
13 psychology

ff-int
0 arts-culture
1 academic-opportunities
2 athletics-recreation
3 housing-dining
4 internships-careers
5 location
6 faculty
7 student-life

**/

(function ($) {
    $(function () {
        var form = $('#ff-form'),
            formWrap = $('#ff-form-wrap'),
            sections = formWrap.find('.section'),
            section_start = '#ff-section-start',
            section_who = '#ff-section-who',
            section_degrees = '#ff-section-degrees',
            section_location = '#ff-section-location',
            section_locationInt = '#ff-section-location-int',
            section_academics = '#ff-section-academics',
            section_academicsGrad = '#ff-section-academics-grad',
            section_interests = '#ff-section-interests',
            //submitBtn = form.find('input[type="submit"]'),
            submitBtn = form.find('#ffSubmitBtn'),
            nextBtn = 'a.next',
            backBtn = $('#ff-back'),
            steps = [],
            activeClass = 'active',
            focusClass = 'focused',
            disabledClass = 'disabled';

        /* HELPER FUNCTIONS */
        var hideSections = function () {
            sections.hide();
        }
        submitBtn.on('click', function () {
            form.submit();
        });

        var showSection = function (section, stepBack) {
            stepBack = stepBack || false;

            hideSections();
            $(section).fadeIn('fast');

            if (!stepBack) {
                steps.push(section);
            }
            else {
                // stepping back, remove last step from the array and hide submit button
                steps.pop();
                submitBtn.hide();
            }
        }

        var flagEl = function (el) {
            $(el).addClass('flagged').focus();
        }

        var unflagEl = function (el) {
            $(el).removeClass('flagged');
        }

        /* BIND NEXT BUTTONS */
        $(section_start).find(nextBtn).on('click', function (e) {
            e.preventDefault();
            showSection(section_who);
        });

        $(section_who).find(nextBtn).on('click', function (e) {
            e.preventDefault();

            var field = $('#ff-who'),
                fieldWrap = $('#ff-section-who .selectric'),
                val = field.val();

            if (val == '') {
                flagEl(fieldWrap);
            }

            if (val == '0' || val == '1') {
                unflagEl(fieldWrap);
                showSection(section_academics);
                backBtn.show();
            }

            if (val == '5') {
                unflagEl(fieldWrap);
                showSection(section_locationInt);
                backBtn.show();
            }

            if (val == '2' || val == '3' || val == '4') {
                unflagEl(fieldWrap);
                showSection(section_degrees);
                backBtn.show();
            }
        });

        $(section_degrees).find(nextBtn).on('click', function (e) {
            e.preventDefault();

            var fieldWrap = section_degrees + ' > fieldset .note',
                selected = form.find('input[name="ff-d"]:checked');

            if (selected.length) {
                unflagEl(fieldWrap);
                showSection(section_location);
            }
            else {
                flagEl(fieldWrap);
            }
        });

        $(section_location).find(nextBtn).on('click', function (e) {
            e.preventDefault();

            var errorField = section_location + ' > fieldset .note',
                selected = form.find('input[name="ff-loc"]:checked');

            if (selected.length) {
                unflagEl(errorField);
                showSection(section_academicsGrad);
            }
            else {
                flagEl(errorField);
            }
        });

        $(section_locationInt).find(nextBtn).on('click', function (e) {
            e.preventDefault();

            var errorField = section_locationInt + ' > fieldset .note',
                selected = form.find('input[name="ff-lci"]:checked');

            if (selected.length) {
                unflagEl(errorField);

                if (selected.val() == '0') {
                    showSection(section_academics);
                }
                else {
                    showSection(section_academicsGrad);
                }
            }
            else {
                flagEl(errorField);
            }
        });

        $(section_academics).find(nextBtn).on('click', function (e) {
            e.preventDefault();

            showSection(section_interests);
            submitBtn.show();
        });

        $(section_academicsGrad).find(nextBtn).on('click', function (e) {
            e.preventDefault();

            var errorField = section_academicsGrad + ' > fieldset .note',
                selected = form.find('input[name="ff-acg"]:checked');

            if (selected.length > 0 && selected.length <= 3) {
                unflagEl(errorField);

                submitBtn.click();
            }
            else {
                flagEl(errorField);
            }
        });

        /* BIND BACK BUTTON */
        $('#ff-back').on('click', function (e) {
            e.preventDefault();
            var sectionToShow = steps[steps.length - 2];

            showSection(sectionToShow, true);

            if (sectionToShow == '#ff-section-who') {
                backBtn.hide();
            }
        });

        /* BIND SUBMIT BUTTON */
        $("#ff-form").on('submit', function (e) {
            var who = $('#ff-who').val(),
            where = document.getElementById('ff-location-int-united-states').checked,
            url = "";
            $.each($(this).serializeArray(), function (i, field) {
                url = url + ((url === "")?"?":"&") + field.name + "=" + field.value;
            });
            Cookies.set('fyfsticky', "1");
            if (who == '0' || who == '1' || (who == '5' && where)) {
                Cookies.set('fyfresults', $("#ucg-results-page").val()+url);
                $("#ff-form").attr("action", $("#ucg-results-page").val());
                return;
            }
            else {
                Cookies.set('fyfresults', $("#vnl-results-page").val()+url);
                $("#ff-form").attr("action", $("#vnl-results-page").val());
                return;
            }
            event.preventDefault();
        });

        /* LOAD FIRST SLIDE */
        hideSections();
        submitBtn.hide();
        backBtn.hide();
        showSection(section_start);

        /* UI ADJUSTMENTS */
        $('#ff-who').selectric(
          {
              responsive: true,
              arrowButtonMarkup: "<span class='button'></span>",
              disableOnMobile: true
          }
        );

        form.find('.checks-blocks').each(function (idx, itm) {
            var contain = $(itm);

            contain.find('input').on('focus', function () {
                $(this).parent().addClass(focusClass);
            });

            contain.find('input').on('blur', function () {
                $(this).parent().removeClass(focusClass);
            });

            contain.find('.item').on('mouseleave', function () {
                contain.removeClass(focusClass);
                $(this).find('input').blur();
            })

            contain.find('input').on('change', function () {
                $(this).parent().toggleClass(activeClass);

                contain.attr('data-selectedCount', contain.find('input:checked').length);

                var notChecked = contain.find('input:not(:checked)');

                if (contain.find('input:checked').length == 3) {
                    notChecked.attr('disabled', true);

                    notChecked.each(function (idx, itm) {
                        $(itm).parent().addClass(disabledClass);
                    });
                }
                else {
                    notChecked.removeAttr(disabledClass);

                    notChecked.each(function (idx, itm) {
                        $(itm).parent().removeClass(disabledClass).removeClass(focusClass);
                    });
                }
            });
        });

        form.find('.checks-cards').each(function (idx, itm) {
            var contain = $(itm);

            contain.find('input').on('focus blur', function () {
                $(this).parent().toggleClass(focusClass);
            });

            contain.find('input').on('change', function () {
                var that = $(this);

                if (that.is(':checked')) {
                    that.parent().addClass(activeClass);
                }
                else {
                    that.parent().removeClass(activeClass).removeClass(focusClass);
                }
            });
        });

        form.find('.checks-cards .item').on('click', function () {
            var that = $(this),
                checkbox = that.find('input');

            that.toggleClass(activeClass);

            if (that.hasClass(activeClass)) {
                checkbox.prop('checked', true);
            }
            else {
                checkbox.prop('checked', false);
            }
        });
    })
})($JQ);